import React, { FC } from "react";
import { useCurrencySymbol } from "hooks/useCurrencySymbol";
import { useTranslation } from "react-i18next";
import { Currency } from "../../../../styles/parcelsStyles";
import { BalanceCard, BalanceValue } from "./BooksBalance.styles";

interface BooksBalanceProps {
  balance: string | number;
}

const BooksBalance: FC<BooksBalanceProps> = React.memo(({ balance }) => {
  const { t } = useTranslation("common");
  const currencySymbol = useCurrencySymbol();

  return (
    <BalanceCard>
      {t("account.balance")}:
      <BalanceValue>
        <Currency>{currencySymbol}</Currency> {balance}
      </BalanceValue>
    </BalanceCard>
  );
});

export default BooksBalance;
